import { InjectionToken, inject } from '@angular/core';
import { AggregationsHubService } from './aggregations.hub.service';

export const AGGREGATIONS_SIGNALR_HUB =
    new InjectionToken<AggregationsHubService>('AGGREGATIONS_SIGNALR_HUB', {
        providedIn: 'root',
        factory: () => inject(AggregationsHubService),
    });
